import { Controller } from "stimulus";

// TEST BENCH: DeepL/Gladia switch for the live captions. Both models run inside
// live_captions_controller.js (see its GLADIA-SPECIFIC section); all this does is flip that
// controller's `provider` value, which reacts by restarting the session on the other model over
// the same audio pipeline and the same transcript.
//
// Kept out of the captions controller itself so the bench UI — button states, labels — can be
// deleted in one file when the evaluation is over.
const PROVIDERS = {
  deepl: "DeepL",
  gladia: "Gladia"
};

export default class extends Controller {
  static targets = ["host", "button", "label"];

  static values = {
    provider: { type: String, default: "deepl" }
  };

  connect() {
    this.syncButtons();
  }

  switchTo(event) {
    event?.preventDefault();

    const provider = event?.currentTarget?.dataset?.captionProvider;
    if (!provider || !PROVIDERS[provider] || provider === this.providerValue) {
      return;
    }

    this.providerValue = provider;
    // Only one provider is ever live: this replaces the session rather than adding one, so the
    // comparison never costs two microphone captures or two sets of billed minutes at once.
    this.hostTarget.setAttribute("data-live-captions-provider-value", provider);
    this.syncButtons();
  }

  syncButtons() {
    this.buttonTargets.forEach((button) => {
      const isActive = button.dataset.captionProvider === this.providerValue;
      button.dataset.active = isActive ? "true" : "false";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = PROVIDERS[this.providerValue];
    }
  }
}
